import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';
import { Row, Col, Button } from 'rsuite';

function TimeSlotsSelection({ timeSlots, onSelect, selected }) {
  const handleSelectSlot = time => () => {
    onSelect(time);
  };

  return (
    <Row>
      <Col xs={24}>
        {map(
          ({ label, time, slots, reservedSlots }) => (
            <Button
              key={time}
              size="sm"
              appearance={selected === time ? 'ghost' : 'default'}
              onClick={handleSelectSlot(time)}
              style={{
                marginRight: 10,
                marginBottom: 10,
                fontWeight: selected === time ? 'bold' : 'normal'
              }}
              disabled={slots > 0 && slots <= reservedSlots}
            >
              {label}
            </Button>
          ),
          timeSlots
        )}
      </Col>
    </Row>
  );
}

TimeSlotsSelection.propTypes = {
  timeSlots: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.string
};

TimeSlotsSelection.defaultProps = {
  selected: null
};

export default TimeSlotsSelection;
